
import {
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer,
    RaikoGridOneColumn, RaikoLabel, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {HabitationMonitoringService} from "../../../serverService/habitationMonitoring/HabitationMonitoringService";
import React, {useEffect, useState} from "react";
import AreaChartDailyPopulation from "./AreaChartDailyPopulation";


export default function HabitationMonitoringAreaChartDailyPopulation({periodId, refreshFlag = false}) {

    const service = new HabitationMonitoringService()


    const [dailyPopulationData, setDailyPopulationData] = useState([])

    function getDataFromServer() {
        service.getDailyPopulationReport(periodId)
            .then(response => {
                setDailyPopulationData([])
                response.items.map((item, index) => {
                    setDailyPopulationData(prev => [
                        ...prev,
                        {
                            name: convertUniversalDateToPersianDate(item.date),
                            value: item.totalPeople,
                            capacity: response.capacityOfAcceptation,
                            // men: item.totalMen,
                            // women: item.totalWomen,
                        },
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {

        })
    }

    useEffect(() => {
        if (typeof periodId !== "undefined" && periodId >= 0) {
            getDataFromServer()
        }
    }, [periodId]);

    useEffect(() => {
        if (typeof refreshFlag !== "undefined" && refreshFlag) {
            getDataFromServer()
        }
    }, [refreshFlag]);


    return (
        <RaikoBaseCardContainer className={css`height: 100%;`}>
            <RaikoGridOneColumn className={css`height: 100%;
                grid-auto-rows: auto 1fr;`}>
                <RaikoLabel text={"جمعیت روزانه ی اسکان"} className={css`height: fit-content;`}/>
                <AreaChartDailyPopulation dailyPopulationData={dailyPopulationData}/>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    );
}
